import { useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';
import contactsSelectors from '@/redux/contacts/contactsSelectors';

import logoMp from '@/images/marketPets/logo-mp.webp';

import s from './marketPets.module.css';

const MP_URL = import.meta.env.VITE_MP_URL;

function MarketPets() {
  const i18n = useSelector(appSelectors.translation);
  const lang = useSelector(appSelectors.language);
  const socials = useSelector(contactsSelectors.socials);

  const tgUrl = socials?.find(
    ({ title_en }) => title_en === 'Telegram',
  )?.description;

  return (
    <div className={s.block}>
      <div className={s.flex_wrapper}>
        <div className={s.badge_title_wrapper}>
          <p className={s.badge}>market pets</p>
          <p className={s.title}>{i18n.Участвуйте_в_конкурсах_трейдеров}!</p>
        </div>

        <div className={s.logo_under_title_wrapper}>
          <img src={logoMp} alt="market pets" className={s.logo} />
          <p className={s.under_title}>
            {i18n.Соревнуйтесь_выигрывайте_и_расширяйте}!
          </p>
        </div>
      </div>

      <div className={s.image} />

      <p className={s.text}>{i18n.Погрузитесь_в_мир}.</p>

      <div className={s.btns_wrapper}>
        <a
          href={tgUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={s.btn_play}
        >
          {i18n.перейти_в_игру}
        </a>
        <a
          href={`${MP_URL}?lang=${lang}`}
          target="_blank"
          rel="noopener noreferrer"
          className={s.btn_more}
        >
          {i18n.подробнее}
        </a>
      </div>
    </div>
  );
}

export default MarketPets;
